import { render, staticRenderFns } from "./VacantBed.vue?vue&type=template&id=79ca0b83&"
import script from "./VacantBed.vue?vue&type=script&lang=js&"
export * from "./VacantBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports